import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIGURATION_TOKEN } from '../app-configuration';
import { ITspTreatmentRepository } from './Itsp-treatment.repository';
import { ApiResponse, PatientTreatmentSettings, TreatmentPlanSettings, TreatmentSettings } from './models';


@Injectable({ providedIn: 'root' })
export class TspTreatmentRepository implements ITspTreatmentRepository {

	private readonly httpClient = inject(HttpClient);
	private readonly configs = inject(APP_CONFIGURATION_TOKEN);


	publish(caseId: string, settings: PatientTreatmentSettings): Observable<ApiResponse<void>> {
		const params = new HttpParams().set('caseId', caseId);
		return this.httpClient.post<ApiResponse<void>>(this.configs.domainTspAPI + '/api/Treatment/Publish', settings, { params });
	}

	publishedProgressToDate(patientId: string, userId: string): Observable<ApiResponse<TreatmentPlanSettings[]>> {
		const params = new HttpParams().set('patientId', patientId).set('userId', userId);
		return this.httpClient.get<ApiResponse<TreatmentPlanSettings[]>>(this.configs.domainTspAPI + '/api/Treatment/PublishedProgressToDate', { params: params });
	}

	getTreatmentPlan(caseId: string, userId: string): Observable<ApiResponse<TreatmentPlanSettings>> {
		const params = new HttpParams().set('caseId', caseId).set('userId', userId);
		return this.httpClient.get<ApiResponse<TreatmentPlanSettings>>(this.configs.domainTspAPI + '/api/Treatment/Get', { params });
	}

	saveSettings(caseId: string, settings: TreatmentSettings): Observable<ApiResponse<void>> {
		const params = new HttpParams().set('caseId', caseId);
		return this.httpClient.patch<ApiResponse<void>>(this.configs.domainTspAPI + '/api/Treatment/Settings', settings, { params });
	}

	revoke(caseId: string): Observable<ApiResponse<void>> {
		const params = new HttpParams().set('caseId', caseId);
		return this.httpClient.patch<ApiResponse<void>>(this.configs.domainTspAPI + '/api/Treatment/Revoke', null, { params });
	}

	revokeAll(patientId: string): Observable<ApiResponse<void>> {
		const params = new HttpParams().set('patientId', patientId);
		return this.httpClient.patch<ApiResponse<void>>(this.configs.domainTspAPI + '/api/Treatment/RevokeAll', null, { params });
	}

}
